import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';

const FacilityResidentsDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  flagged: z.boolean(),
  activeAlerts: z.number(),
  createdAlerts: z.number(),
  daysSinceReview: z.number(),
  rate: z.number(),
  revenue: z.number(),
  payerType: z.string(),
  levelOfCare: z.number().positive(),
  daysOnCareLevel: z.number().positive(),
  lengthOfStay: z.number().positive(),
});

const GetFacilityResidentsResponseDtoSchema = PagePaginationResponseDtoSchema(
  FacilityResidentsDtoSchema
);

export type GetFacilityResidentsRequestDto = PagePaginationRequestDto<
  { facilityId: string },
  | 'name'
  | 'flagged'
  | 'activeAlerts'
  | 'createdAlerts'
  | 'daysSinceReview'
  | 'rate'
  | 'revenue'
  | 'payerType'
  | 'levelOfCare'
  | 'daysOnCareLevel'
  | 'lengthOfStay'
>;
export type GetFacilityResidentsResponseDto = z.infer<
  typeof GetFacilityResidentsResponseDtoSchema
>;
export type FacilityResidentsDto = z.infer<typeof FacilityResidentsDtoSchema>;

export const getFacilityResidents = (
  params: GetFacilityResidentsRequestDto,
  config?: AxiosRequestConfig<GetFacilityResidentsRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/facilities/${facilityId}/residents`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetFacilityResidentsResponseDtoSchema));
};
